import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Home from "./components/Home";
import theme from "./theme";
import { useContext } from "react";
import AuthContext from "./context/AuthContext";

// Rutas privadas
const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;




// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Button from '@mui/material/Button';
// //import logo from './logo.svg';
// import './App.css';
// import Home from './components/Home';
// import Login from './components/Login';
// import PigCounter from './components/PigCounter';

// function App() {
//   return (
//     <div className='App'>
//       <Router>
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/pig-counter" element={<PigCounter />} />
//         </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;
